import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  gymData: localStorage.getItem("gymData")
    ? JSON.parse(localStorage.getItem("gymData"))
    : null,
};

const gymDataSlice = createSlice({
  name: "gymData",
  initialState,
  reducers: {
    setGymData: (state, action) => {
      state.gymData = action.payload;
      localStorage.setItem("gymData", JSON.stringify(action.payload));
    },
    clearGymData: (state) => {
      state.gymData = null;
      localStorage.removeItem("gymData");
    },
  },
});

export const { setGymData, clearGymData } = gymDataSlice.actions;

export default gymDataSlice.reducer;
